// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/assets/stylesheets/local/styles.css';
import SliderHome from '../components/home/sliderHome/Sliderhome';
import ProduitHome from '../components/home/produit/ProduitsHome';
import ChiffreContent from '../components/kit/chiffre-content';
import Hotline from '../components/kit/hotline.js';
import Values from '../components/kit/Values.js';
import Agences from '../components/kit/agences';
import WithLoading from '../hoc/withLoading';
import Step from '../components/home/leasingStep/leasingStep';
import useFetch from '../hooks/useFetch';
import { Link } from 'gatsby';
import CarousselNews from '../components/home/carousselNews/CarousselNews';

const AgencesWithLoading = WithLoading(Agences);
const SliderWithLoading = WithLoading(SliderHome);
const ProduitWithLoading = WithLoading(ProduitHome);
const ValuesWithLoading = WithLoading(Values);
const ChiffreWithLoading = WithLoading(ChiffreContent);
const StepWithLoading = WithLoading(Step);
const LayoutWithLoading = WithLoading(Layout);
const NewsWithLoading = WithLoading(CarousselNews);

export default () => {
	const [reload, setReload] = useState({ endPoint: null, isClicked: 0 });

	const values = useFetch(`valeurs?populate=*`, [{}], reload);
	const agencies = useFetch(`agences`, [{}], reload);
	const aPropos = useFetch(`a-propos`, {}, reload);
	const dataslider = useFetch(`slider-homes?_sort=id:asc&populate=*`, [{}], reload);
	const dataProduits = useFetch(`produit-homes?_sort=id:asc&populate=*`, [{}], reload);
	const dataChiffre = useFetch(`chiffre-homes?populate=*`, [{}], reload);
	const step = useFetch(`etape-leasings?_sort=number:asc&populate=*`, [{}], reload);
	const news = useFetch(`actualites`, [{}], reload);

	const handleClick = (endPoint) => {
		setReload({ ...reload, endPoint: endPoint, isClicked: reload.isClicked + 1 });
	};

	const generalLoader =
		values.loading &&
		agencies.loading &&
		aPropos.loading &&
		dataslider.loading &&
		dataProduits.loading &&
		dataChiffre.loading &&
		step.loading;

	const settings_caroussel_valeur = {
		infinite: !0,
		dots: !0,
		vertical: !0,
		verticalSwiping: !0,
		centerMode: !0,
		arrows: !1,
		autoplay: true,
		autoplaySpeed: 2000,
		className: 'caroussel-valeur ',
	};
	const handleScroll = (e) => {};

	//console.log('dataSlider',dataslider);
	return (
		<LayoutWithLoading title="Maroc Leasing Home page" isLoading={generalLoader} isLayout>
			<div className="page">
				<div className="section--1">
					<div className="row">
						<div className="col-md-6">
							<div className="caroussel-home">
								<SliderWithLoading
									isLoading={dataslider.loading}
									isError={dataslider.error}
									endPoint={dataslider.endPoint}
									handleClick={handleClick}
									sliders={dataslider.data}
								/>
							</div>
						</div>
						{
							<ProduitWithLoading
								isLoading={dataProduits.loading}
								isError={dataProduits.error}
								endPoint={dataProduits.endPoint}
								handleClick={handleClick}
								product={dataProduits.data}
							/>
						}
					</div>
				</div>
				<div className="section--2">
					<div className="container">
						<h2>A propos</h2>
						<div className="row">
							<div className="col-md-8 content">
								<h3>{aPropos.data[0] && aPropos.data[0].titre},</h3>
								<p>Créée en 1965, Maroc Leasing a été la toute première entreprise de leasing au Maroc. </p>
								<p>
									Cotée à la Bourse de Casablanca et s’appuyant sur l’expérience d’une centaine de
									collaborateurs, Maroc Leasing vous propose un accompagnement personnalisé, pour vous
									aider...
								</p>
								{/* <a className="btn blue" href="/apropos">
									EN savoir plus
								</a> */}
								<Link className="btn blue" to="/apropos">
									{' '}
									EN savoir plus
								</Link>
							</div>
							<div className="col-md-4 chiffre">
								<ChiffreWithLoading
									isLoading={dataChiffre.loading}
									isError={dataChiffre.error}
									data={values.data}
									endPoint={values.endPoint}
									handleClick={handleClick}
									chiffre={dataChiffre.data}
								/>
							</div>
						</div>
					</div>
					<div className="nos-valeur-home bg-gris p-t-30 p-b-30">
						<div className="container">
							<div className="col-md-12 title">
								<h2>NOS VALEURS</h2>
							</div>
							<ValuesWithLoading
								isLoading={values.loading}
								isError={values.error}
								data={values.data}
								endPoint={values.endPoint}
								handleClick={handleClick}
								source="home"
							/>
						</div>
					</div>
				</div>
				<div className="section--5">
					<div className="container">
						<div className="row">
							<div className="col-md-4 title">
								<h2>
									LEASING <br />
									EN 5 ETAPES
								</h2>
							</div>
							<div className="col-md-8">
								<StepWithLoading
									isLoading={step.loading}
									isError={step.error}
									endPoint={step.endPoint}
									handleClick={handleClick}
									step={step.data}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="hr">
					<hr />
				</div>
				<div className="section--3">
					<div className="container">
						<div className="row">
							<div className="col-md-7 col-sm-12 bloc-espace-client">
								<div className="content">
									<h2>ESPACE CLIENT</h2>
									<p>
										Pour mieux vous accompagner dans la gestion de vos contrats, nous avons le plaisir de
										mettre à votre disposition l’Espace client leasing de Maroc Leasing : Une solution en
										ligne pour gérer et suivre vos contrats de crédit-bail, simplement, en toute autonomie et
										de façon sécurisée.
									</p>
									<ul>
										<li key="1">
											<span className="icon">
												<img src={require('../../styles/medias/images/person.svg')} />
											</span>
											Sécurité
										</li>
										<li key="2">
											<span className="icon">
												<img src={require('../../styles/medias/images/database.svg')} />
											</span>
											Disponibilité
										</li>
										<li key="3">
											<span className="icon">
												<img src={require('../../styles/medias/images/performance.svg')} />
											</span>
											Rapidité
										</li>
									</ul>
									<a className="btn orange-bg" href={process.env.GATSBY_API_URL_MLNET} target="_blank">
										CONNECTEZ-VOUS
									</a>
								</div>
							</div>
							<div className="col-md-5 col-sm-12 liste">
								<div className="content">
									<div className="image">
										<img src={require('../../styles/medias/images/agefis-vll0Bb04XTc-unsplash.png')} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="hr">
					<hr />
				</div>
				<div className="section--3 espace-partenaire">
					<div className="container">
						<div className="row">
							<div className="col-md-7 col-sm-12 bloc-espace-client">
								<div className="content">
									<h2>Espace Partenaire</h2>
									<p>
										Nous avons pensé un outil au service de votre efficacité commerciale. Un espace web dédié
										pour la gestion et le suivi des dossiers de financement de vos clients.
									</p>
									<ul>
										<li key="1">
											<span className="icon">
												<img src={require('../../styles/medias/images/slider-circle-h.svg')} />
											</span>
											Simulations <br />
											en ligne
										</li>
										<li key="2">
											<span className="icon">
												<img src={require('../../styles/medias/images/attach-document.svg')} />
											</span>
											Demandes
											<br /> de financement
										</li>
										<li key="3">
											<span className="icon">
												<img src={require('../../styles/medias/images/file-search.svg')} />
											</span>
											Suivi de bons
											<br /> de commandes
											<br /> et règlement des factures
										</li>
									</ul>
									<a className="btn bleu-bg" href={process.env.GATSBY_API_URL_FOURNISSEUR} target="_blank">
										CONNECTEZ-VOUS
									</a>
								</div>
							</div>
							<div className="col-md-5 col-sm-12 liste">
								<div className="content">
									<div className="image">
										<img src={require('../../styles/medias/images/image-partenaire.png')} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<AgencesWithLoading
					isLoading={agencies.loading}
					isError={agencies.error}
					endPoint={agencies.endPoint}
					handleClick={handleClick}
					agences={agencies.data}
				/>
				{/* <div className="section--7">
                    <div className="container">
                        <div className="title"><h2>DERNIERES ACTUALITES</h2></div>
                        <CarousselNews/> 
                        <NewsWithLoading isLoading={news.loading} isError={news.error} endPoint={news.endPoint} handleClick={handleClick} news={news.data}/>
                    </div>
                </div>*/}
			</div>
			{/* <div className="cookie">
                <div className="container">
                    <div className="content">
                        En poursuivant votre navigation sur ce site, vous acceptez l'utilisation des cookies.
                        <button className="btn-c bleu">J'accepte les cookies</button>
                        <a href="/" className="btn-c white">Lire notre  politique de confidentialité</a>
                        <div className="close">&nbsp;</div>
                    </div>
                </div>
            </div> */}
		</LayoutWithLoading>
	);
};
